/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Videos_Exclude_PortalInputs */

const cs_videos_exclude_portal = /** @type {(inputs: Videos_Exclude_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyloučit z exportu na portály`)
};

const en_videos_exclude_portal = /** @type {(inputs: Videos_Exclude_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exclude from portal export`)
};

/**
* | output |
* | --- |
* | "Exclude from portal export" |
*
* @param {Videos_Exclude_PortalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const videos_exclude_portal = /** @type {((inputs?: Videos_Exclude_PortalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Videos_Exclude_PortalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_videos_exclude_portal(inputs)
	return cs_videos_exclude_portal(inputs)
});